import styled from 'styled-components'
import { black, authGradientStart, white } from '../components/colors';
export const AuthContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-image: radial-gradient(${authGradientStart} 0%, ${black} 100%);
  align-items: center;
  justify-content: center;
`

export const LogoText = styled.img``

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  gap: 16px;
  & > img {
    height: 60px;
    width: auto;
  }

  & > ${LogoText} {
    height: 56px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: ${white};
  overflow-y: auto;
  align-items: center;
  gap: 48px;
  padding-top: 72px;
  padding-bottom: 72px;
  padding-left: 36px;
  padding-right: 36px;
`